// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import ClickCopyController from "./click_copy_controller"
application.register("click-copy", ClickCopyController)

import CommunityProductsController from "./community_products_controller"
application.register("community-products", CommunityProductsController)

import DismissibleController from "./dismissible_controller"
application.register("dismissible", DismissibleController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import InlineRateCellController from "./inline_rate_cell_controller"
application.register("inline-rate-cell", InlineRateCellController)

import LtvValidatorController from "./ltv_validator_controller"
application.register("ltv-validator", LtvValidatorController)

import MapController from "./map_controller"
application.register("map", MapController)

import MarkdownEditorController from "./markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import PropertyTypeController from "./property_type_controller"
application.register("property-type", PropertyTypeController)

import QuoteExplorerController from "./quote_explorer_controller"
application.register("quote-explorer", QuoteExplorerController)

import QuoteFormController from "./quote_form_controller"
application.register("quote-form", QuoteFormController)

import QuoteLocationController from "./quote_location_controller"
application.register("quote-location", QuoteLocationController)

import QuotePricingController from "./quote_pricing_controller"
application.register("quote-pricing", QuotePricingController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import RiskAdjustmentFormController from "./risk_adjustment_form_controller"
application.register("risk-adjustment-form", RiskAdjustmentFormController)

import ShareGeneratorController from "./share_generator_controller"
application.register("share-generator", ShareGeneratorController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TinyMdeController from "./tiny_mde_controller"
application.register("tiny-mde", TinyMdeController)
